module.exports = __webpack_public_path__ + "static/media/orga4.dfe40bbc.svg";